/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { Loader } from '@locus-taxy/neo-ui';

import { fetchSession } from 'common/redux/actions/session';
import { AuthenticationActions } from 'common/modules/auth';
import { ApiStatusEnum } from 'common/enums/API';
import { ApiError } from 'common/modules/api';
import { RetrySnackbar } from 'common/components/core/snackbar';

type Props = {
    children: React.Node
};

const useGetSession = () => {
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ['session', 'me'],
        queryFn: async () => {
            await dispatch(fetchSession());
        },
        // fetch only once
        staleTime: Infinity
    });
};

const Logout = () => {
    // logout on mount
    React.useEffect(() => {
        AuthenticationActions.logout({
            returnTo: window.location.href
        });
    }, []);

    return null;
};

const SessionFetcher = ({ children }: Props): React.Node => {
    const sessionQuery = useGetSession();
    const { t } = useTranslation();

    if (sessionQuery.status === ApiStatusEnum.Loading) {
        return (
            <Loader size="large" width="100%" height="100%" color="blue.500" />
        );
    }

    if (sessionQuery.status === ApiStatusEnum.Error) {
        const { error } = sessionQuery;
        if (error instanceof ApiError && error.status === 401) {
            return <Logout />;
        }

        return (
            <RetrySnackbar
                errorMessage={t('loadingSessionFailed')}
                onClick={() => sessionQuery.refetch()}
            />
        );
    }

    return children;
};

export default SessionFetcher;
